import { render, staticRenderFns } from "./CertificatesQuery.vue?vue&type=template&id=ef47aeb2&scoped=true&"
import script from "./CertificatesQuery.vue?vue&type=script&lang=js&"
export * from "./CertificatesQuery.vue?vue&type=script&lang=js&"
import style0 from "./CertificatesQuery.vue?vue&type=style&index=0&id=ef47aeb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef47aeb2",
  null
  
)

export default component.exports